import { EntityStore, EntityState, StoreConfig } from '@datorama/akita';
import { Attachment } from '../models/attachment.model';
import { Injectable } from '@angular/core';

export interface AttachmentEntity {
  attachments: Attachment[];
  storeEntityId: number | string;
}

export type AttachmentsState = EntityState<AttachmentEntity>

/**
 * Stores attachments arrays for projects and external pitch
 */
@StoreConfig({
  name: 'attachments',
  idKey: 'storeEntityId'
})
@Injectable({
  providedIn: 'root'
})
export class AttachmentsStore extends EntityStore<AttachmentsState, AttachmentEntity> {
  constructor() {
    super();
  }
}
